<template>

<div class="carousel">
    
    <owl-carousel :items='owlItems' :opts='owlOptions' :ocid='owlId' ></owl-carousel>
    
</div>

</template>

<script>
    export default {

        mounted() {

        },

        created() {
           
        },

        data() {
            return {
                isReady : false,

                owlId : 'single-project',

                owlItems : [
                    { id : 1, image : '/resources/images/static/variant1.jpg', alt : 'Title' },
                    { id : 2, image : '/resources/images/static/variant2.jpg', alt : 'Title' },
                    { id : 3, image : '/resources/images/static/variant3.jpg', alt : 'Title' },
                    { id : 4, image : '/resources/images/static/variant4.jpg', alt : 'Title' },
                    { id : 5, image : '/resources/images/static/variant5.jpg', alt : 'Title' },
                    { id : 6, image : '/resources/images/static/variant6.jpg', alt : 'Title' },
                    { id : 7, image : '/resources/images/static/variant7.jpg', alt : 'Title' }
                ],

                owlOptions : {
                    loop            : true,
                    center          : true,
                    nav             : true,
                    items           : 1,
                    margin          : 10,
                    stagePadding    : 30,
                    responsive:{
                        600 : {
                           items    : 3,
                        }
                    }
                },

            }
        },

        methods : {

        }

    }
</script>
